






















import Cart from '@/components/Cart.vue';
import RequestQuote from '@/graphql/mutations/requestQuote.gql';
import ProceduresBasic from '@/graphql/queries/proceduresBasic.gql';
import request from '@/graphql/request';
import Vue from 'vue';
import Component from 'vue-class-component';

interface IProcedureBasic {
  id: string;
  name: string;
  description: string;
}

@Component({})
export default class Procedures extends Vue {
  public proceduresTitle: { name: string } = { name: 'PROCEDURES' };
  public subProcedures: { name: string } = {
    name: 'Our clinics are proven safe and effective.',
  };
  public search: string = '';
  public procedures: IProcedureBasic[] = [];

  public mounted() {
    request(ProceduresBasic)
      .then(response => {
        if (!response || !response.data) {
          console.error('No procedures returned');
          return;
        }

        this.procedures = response.data.procedures;
      })
      .catch(console.error);
  }

  get filteredProcedures() {
    return this.procedures.filter(
      proc => proc.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
    );
  }

  public addToCart(procedureId: string) {
    this.$store.dispatch('cart/addProcedure', procedureId);
    console.dir(this.$store.getters['cart/procedures']);
  }
}
